import API from './API';

export default API;
